import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/videos';

export default function HeroCarousel() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroSlides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) => {
    setCurrent((prev) => (prev + dir + heroSlides.length) % heroSlides.length);
  };

  const slide = heroSlides[current];

  return (
    <section className="relative w-full">
      <div className="relative h-[440px] w-full overflow-hidden md:h-[560px]">
        {heroSlides.map((item, index) => (
          <div
            key={item.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === current ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={item.cover}
              alt={item.title}
              title={`${item.title} - 麻豆精品入口蜜桃精选推荐`}
              className="h-full w-full object-cover object-top"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-background-950/80 via-background-950/45 to-background-950/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 to-transparent" />

        <div className="absolute inset-0 flex items-center">
          <div className="mx-auto w-full px-4 md:px-6">
            <div key={slide.id} className="max-w-xl animate-fade-up">
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                <i className="ri-fire-line" />
                {slide.tag}
              </span>
              <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-background-50 md:text-5xl">
                {slide.title}
              </h1>
              <p className="mt-4 text-sm leading-relaxed text-background-100/90 md:text-base">
                {slide.subtitle}
              </p>
              <div className="mt-7 flex flex-wrap items-center gap-3">
                <Link
                  to={`/detail/${slide.linkId}`}
                  className="flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
                >
                  <i className="ri-play-fill text-lg" />
                  立即观看
                </Link>
                <Link
                  to="/category/movie"
                  className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-5 py-2.5 text-sm font-medium text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/20"
                >
                  <i className="ri-compass-3-line text-lg" />
                  浏览分类
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-5 right-4 flex items-center gap-2 md:right-6">
          <button
            type="button"
            onClick={() => go(-1)}
            aria-label="上一张"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/35"
          >
            <i className="ri-arrow-left-s-line text-xl" />
          </button>
          <button
            type="button"
            onClick={() => go(1)}
            aria-label="下一张"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur-sm transition-colors hover:bg-background-50/35"
          >
            <i className="ri-arrow-right-s-line text-xl" />
          </button>
        </div>
      </div>

      <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2 md:left-auto md:right-24 md:translate-x-0">
        {heroSlides.map((item, index) => (
          <button
            key={item.id}
            type="button"
            onClick={() => setCurrent(index)}
            aria-label={`切换到 ${item.title}`}
            className={`h-1.5 rounded-full transition-all ${
              index === current ? 'w-7 bg-primary-400' : 'w-3 bg-background-50/50'
            }`}
          />
        ))}
      </div>
    </section>
  );
}